export default __webpack_public_path__ + "static/media/unemployeecover.3caf5c0a.png";